import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

export const useDocumentTitle = (chatId) => {
  const [chatTitle, setChatTitle] = useState('');

  // Function to update document title
  const updateDocumentTitle = useCallback((title) => {
    if (title && title !== 'New Chat') {
      document.title = title;
    } else if (chatId) {
      document.title = 'New Chat';
    } else {
      document.title = 'Midus';
    }
  }, [chatId]);

  // Fetch chat title when chatId changes
  useEffect(() => {
    if (!chatId) {
      setChatTitle('');
      updateDocumentTitle('');
      return;
    }

    const fetchChatTitle = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/chat/${chatId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data && response.data.chat && response.data.chat.title) {
          setChatTitle(response.data.chat.title);
          updateDocumentTitle(response.data.chat.title);
        }
      } catch (error) {
        console.error('Error fetching chat title:', error);
        // Fallback to default title
        updateDocumentTitle('');
      }
    };

    fetchChatTitle();
  }, [chatId, updateDocumentTitle]);

  // Listen for chat title updates via WebSocket events
  useEffect(() => {
    const handleChatTitleUpdated = (event) => {
      const { chatId: updatedChatId, title } = event.detail;
      
      // Only update if this is the current chat
      if (updatedChatId === chatId) {
        setChatTitle(title);
        updateDocumentTitle(title);
      }
    };

    window.addEventListener('chatTitleUpdated', handleChatTitleUpdated);
    
    return () => {
      window.removeEventListener('chatTitleUpdated', handleChatTitleUpdated);
    };
  }, [chatId, updateDocumentTitle]);

  return { chatTitle, updateDocumentTitle };
}; 